import * as _ from 'lodash'

export interface OptionModel {
    key: string;
    value: string;
}

export enum EventStatus {
    Unknow,
    Active,
    StartingSoon,
    EndingSoon
}

export const eventStatusToString = (status?: EventStatus): string => {
    if (_.isNil(status)) return "";

    switch (status) {
        case EventStatus.Active:
            return "Active";
        case EventStatus.StartingSoon:
            return "Starting Soon";
        case EventStatus.EndingSoon:
            return "Ending Soon";
        default:
            return "Unknown";
    }
}

export interface HeatmapFilterModel {
    neighborhoodIDs?: string[];
    demographicTypeIDs?: string[];
    categoryIDs?: string[];
    fromDate?: Date;
    toDate?: Date;
    quickFilterDays?: number;
    eventStatus?: EventStatus;
    eventName?: string;
    attendanceType?: string;
    merchantName?: string;
}